var map = {
	"./grade-beginner-hollow.png": 6353,
	"./grade-experienced-hollow.png": 5942,
	"./grade-intermediate-hollow.png": 677,
	"./grade-proficient-hollow.png": 1136,
	"./grade-undefined-hollow.png": 4160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4302;